import { toast } from 'react-toastify'
import { getRazorpayLanguageCode } from 'src/consumer/components/EventBooking/BookingHelperFunctions'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { ensureRazorpayLoaded } from 'src/utils/loadRazorpay'

/**
 * Open Razorpay checkout for wallet recharge using payment link payload.
 * payload: { orderId, razorpayClientId, amountInMinorUnit, currencyCode }
 * onSuccess: () => void - called after successful payment
 */
export async function openWalletRazorpay(payload, onSuccess) {
  if (!payload?.razorpayClientId || !payload?.orderId) {
    toast.error('Invalid payment payload')
    return
  }
  try {
    await ensureRazorpayLoaded()
  } catch (error) {
    console.error('[Razorpay] Failed to load checkout.js', error)
    toast.error('Payment gateway is loading. Please try again.')
    return
  }

  const options = {
    key: payload.razorpayClientId,
    amount: payload.amountInMinorUnit ?? payload.amount ?? 0,
    currency: payload.currencyCode || 'INR',
    name: 'AUMHUM',
    description: 'Wallet recharge',
    image: APP_CONSTANTS.APP_LOGO_LINK,
    order_id: payload.orderId,
    handler: function () {
      toast.success('Payment successful')
      onSuccess?.()
    },
    config: {
      display: { language: getRazorpayLanguageCode() },
    },
    theme: { color: '#7154b0' },
  }

  const rzp = new window.Razorpay(options)
  rzp.on('payment.failed', function (response) {
    toast.error(response.error?.description || 'Payment failed')
  })
  rzp.open()
}
